import type { AmsAuditApproval } from '../../../services/amsAuditApprovalService';

export type AuditBucket = 'pending' | 'rejected' | 'approved';

/** The approver-facing bucket for an audit. Draft audits are never shown, so they return null. */
export const getAuditBucket = (approval: AmsAuditApproval): AuditBucket | null => {
  switch (approval.overallStatus) {
    case 'pending_review':
    case 'partially_approved':
      return 'pending';
    case 'rejected':
      return 'rejected';
    case 'approved_to_start':
      return 'approved';
    default: // 'draft'
      return null;
  }
};

/** True when the audit is waiting on the approver (not the requester). */
export const auditNeedsReview = (approval: AmsAuditApproval): boolean =>
  getAuditBucket(approval) === 'pending';
